import { ConfirmModal } from '@components/Modal/ConfirmModal';
import { IData } from '@hooks/useData';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { useModalWindow } from '@hooks/useModalWindow';
import { useValueState } from '@hooks/useValueState';
import ILinha from '@model/Linha';
import { IVendedor } from '@model/Vendedor';
import { IVendedorMovimentacao } from '@model/VendedorMovimentacao';
import { IVendedorMovimentacaoFilter, useVendedorMovimentacaoService } from '@services/VendedorMovimentacaoService';
import React from 'react';
import { VendedorInventarioFilter } from './Filter';
import { FichaVendedorInventarioTable } from './Table';

export type FichaVendedorInventarioProps = {
    data: IData<ILinha, {}>
    dataMovimentacao: IData<IVendedorMovimentacao, IVendedorMovimentacaoFilter>
    isLoading: boolean
    vendedor: IVendedor
}

export function FichaVendedorInventario ({ data, dataMovimentacao, isLoading, vendedor}: FichaVendedorInventarioProps) {
    const confirmModal = useModalWindow();
    const selectedIds = useValueState<number[]>([]);

    const loadingOperation = useLoading();
    const message = useMessage();

    const vendedorMovimentacaoService = useVendedorMovimentacaoService();

    const isAnyLoading = React.useMemo(() => isLoading || loadingOperation.isLoading, [isLoading, loadingOperation.isLoading]);

    const handleResgatar = React.useCallback(() => {
        if (selectedIds.value !== undefined && selectedIds.value.length > 0 && !isAnyLoading) {
            loadingOperation.start();
            vendedorMovimentacaoService.resgatar(vendedor.vendedorId, { linhaIds: selectedIds.value})
                .then(response => {
                    message.success("Linhas resgatadas com sucesso");
                    confirmModal.close();
                    data.filter.handleFilterRequest();
                    dataMovimentacao.filter.handleFilterRequest();
                    window.open(`/ProtocoloMovimentacao/${response.data.vendedorMovimentacaoId}`);
                })
                .catch(message.showBlobException)
                .finally(loadingOperation.stop)
        }
    }, [confirmModal, data.filter, dataMovimentacao.filter, isAnyLoading, loadingOperation, message, selectedIds.value, vendedor.vendedorId, vendedorMovimentacaoService]);

    return (
        <React.Fragment>
            <VendedorInventarioFilter 
                isLoading={isAnyLoading}
                selectedIds={selectedIds.value ?? []}
                confirmModal={confirmModal}
            />

            <FichaVendedorInventarioTable 
                isLoading={isAnyLoading}
                data={data}
                selectedIds={selectedIds}
            />

            <ConfirmModal 
                modal={confirmModal}
                title="Confirmar Resgate"
                content="Tem certeza que deseja resgatar as linhas selecionadas do vendedor ?"
                disabled={isAnyLoading}
                actionProps={{
                    confirmButtonText: "Confirmar Resgate",
                    onConfirm: handleResgatar
                }}
            />
        </React.Fragment>
    )
}